module.exports = __webpack_public_path__ + "static/fonts/notokr-medium.81bd542.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/leader-seminar/font/notokr-medium.woff
// module id = Vt3q
// module chunks = 0